const PlusIcon = ({ size = 50, ...props }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 48.7604C38.2547 48.7604 49 38.0151 49 24.7604C49 11.5055 38.2547 0.760376 25 0.760376C11.7452 0.760376 1 11.5055 1 24.7604C1 38.0151 11.7452 48.7604 25 48.7604Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M33.8825 24L17 24"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M25.4414 15.5586L25.4414 32.441"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
  
  export default PlusIcon;
  